import { SCREENS } from "navigation/consts";
import { createBottomTabNavigator } from "@react-navigation/bottom-tabs";
import { useIntl } from "react-intl";
import { RouteProp, useRoute } from "@react-navigation/native";
import { EventOccurrenceContextProvider } from "contexts/EventOccurrenceContext";
import { RootNavigationParamList } from "navigation/RootNavigation/types";

import EventNavigation from "../EventNavigation";
import ScannerNavigation from "../ScannerNavigation";
import SettingsNavigation from "../SettingsNavigation";

import { MainNavigationParamList } from "./types";
import { EventTabIcon, ScannerTabIcon, SettingsTabIcon } from "./consts";

const { Navigator, Screen } =
  createBottomTabNavigator<MainNavigationParamList>();

const MainNavigation: React.FC = () => {
  const intl = useIntl();
  const {
    params: { eventOccurrenceId },
  } = useRoute<RouteProp<RootNavigationParamList, typeof SCREENS.Main>>();

  return (
    <EventOccurrenceContextProvider value={{ eventOccurrenceId }}>
      <Navigator
        screenOptions={{
          headerShown: false,
          tabBarStyle: {
            height: 64,
            padding: 8,
          },
        }}
      >
        <Screen
          name={SCREENS.EventTab}
          component={EventNavigation}
          options={{
            tabBarLabel: intl.formatMessage({ defaultMessage: "Event" }),
            tabBarIcon: EventTabIcon,
          }}
        />
        <Screen
          name={SCREENS.ScannerTab}
          component={ScannerNavigation}
          options={{
            tabBarLabel: intl.formatMessage({ defaultMessage: "Scanner" }),
            tabBarIcon: ScannerTabIcon,
          }}
        />
        <Screen
          name={SCREENS.SettingsTab}
          component={SettingsNavigation}
          options={{
            tabBarLabel: intl.formatMessage({ defaultMessage: "Settings" }),
            tabBarIcon: SettingsTabIcon,
          }}
        />
      </Navigator>
    </EventOccurrenceContextProvider>
  );
};

export default MainNavigation;
